import type { RouteRecordRaw } from 'vue-router';

/**
 * Fixed Assets web screens (M8, DECISIONS.md "ADR-091 - Fixed Assets (M8)"). Follows the parallel-work
 * convention of `payroll.ts`: `router.ts` only spreads this array into the app-shell children.
 */
export const assetsRoutes: RouteRecordRaw[] = [
  {
    path: 'assets',
    name: 'assets-register',
    component: () => import('../pages/assets/AssetsPage.vue'),
    meta: { requiresModule: 'assets' },
  },
  {
    path: 'assets/register/:id',
    name: 'asset-detail',
    component: () => import('../pages/assets/AssetDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'assets' },
  },
  {
    path: 'assets/classes',
    name: 'assets-classes',
    component: () => import('../pages/assets/AssetClassesPage.vue'),
    meta: { requiresModule: 'assets' },
  },
  {
    path: 'assets/depreciation',
    name: 'assets-depreciation',
    component: () => import('../pages/assets/AssetDepreciationPage.vue'),
    meta: { requiresModule: 'assets' },
  },
  {
    path: 'assets/disposals',
    name: 'assets-disposals',
    component: () => import('../pages/assets/AssetDisposalsPage.vue'),
    meta: { requiresModule: 'assets' },
  },
];
